// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3dnWD","actions":"GroupTable_actions__QrGoB","deleteModalFooter":"GroupTable_deleteModalFooter__GhomQ"};